import type { V2ProjectResource } from "@generated";

export type ColumnFormat = "currency" | "date" | "decimal" | "percent" | "string" | "titleize";
export type SortDirection = "asc" | "desc";

export interface UserViewColumn {
  label: string;
  width: number;
  format?: ColumnFormat;
  data_path: string;
  data_type?: string;
  selected: boolean;
  sortable?: boolean;
  sorted?: SortDirection | "false";
  position: number;
  optional?: boolean;
}

export interface ProjectsViewFilters {
  showMyProjects?: boolean;
  status?: string[];
  clients?: string[];
  salesExecs?: string[];
  presalesEngineers?: string[];
  teams?: string[];
  teammates?: string[];
  tags?: string[];
  tagIds?: string[];
  rateTableIds?: string[];
  lobIds?: string[];
  businessUnits?: string[];
  dateEditedStart?: string;
  dateEditedEnd?: string;
  dateCreatedStart?: string;
  dateCreatedEnd?: string;
}

export interface IncludedRecord {
  id: string;
  type: string;
  attributes?: Record<string, unknown>;
  relationships?: Record<string, { data?: { id: string; type: string } | { id: string; type: string }[] | null }>;
}

export interface ProjectRow {
  id: string;
  project: V2ProjectResource;
  client?: IncludedRecord;
  salesExecutive?: IncludedRecord;
  presalesEngineer?: IncludedRecord;
  isChangeOrder: boolean;
  changeOrderNumber?: number;
  changeOrders: ProjectRow[];
}

export type ProjectsTab = "active" | "building" | "pending" | "approved" | "won" | "lost" | "archived";

export const PROJECT_TABS: { key: ProjectsTab; statuses: string[] }[] = [
  { key: "active", statuses: [] },
  { key: "building", statuses: ["building"] },
  { key: "pending", statuses: ["technical_approval", "sales_approval", "business_approval"] },
  { key: "approved", statuses: ["approved"] },
  { key: "won", statuses: ["won"] },
  { key: "lost", statuses: ["lost"] },
  { key: "archived", statuses: [] },
];

export const tabFromSavedStatus = (status?: string[]): ProjectsTab => {
  const first = status?.[0];
  if (!first) return "active";
  if (first.includes("approval")) return "pending";
  return (PROJECT_TABS.find((t) => t.key === first)?.key ?? "active") as ProjectsTab;
};

export interface ColumnSort {
  key: string;
  direction: SortDirection;
}
